import React, { ReactNode } from 'react';
import { TextHeadingThree } from '@cko/primitives';
import {
  StyledColumnContainer,
  StyledContentContainer,
  StyledGridContainer,
  StyledGridRowDivider,
} from './GridView.styles';

type GridViewProps = {
  noOfColumns?: number;
  children: ReactNode[];
};

export const GridViewContent = (props: { title: string; children: ReactNode }) => {
  return (
    <StyledColumnContainer>
      <TextHeadingThree>{props.title}</TextHeadingThree>
      <StyledContentContainer>{props.children}</StyledContentContainer>
    </StyledColumnContainer>
  );
};

export const GridView = ({ noOfColumns = 3, children }: GridViewProps) => (
  <StyledGridContainer col={noOfColumns}>
    {children.map((node: ReactNode, index: number) => {
      const showDivider = (index + 1) % noOfColumns === 0 && index !== children.length - 1;
      return (
        <>
          {node}
          {showDivider ? <StyledGridRowDivider col={noOfColumns} /> : null}
        </>
      );
    })}
  </StyledGridContainer>
);
